import styled from 'styled-components';

const StyledContainer = styled.div<{ $active: boolean }>`
	position: relative;

	img {
		position: absolute;
		top: 50%;
		right: 20px;
		transform: translateY(-50%);
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
		opacity: ${(props) => (props.$active ? 1 : 0.5)};
	}

	&:hover {
		img {
			filter: invert(100%);
			opacity: 1;
		}
	}

	input:not(:placeholder-shown) {
		font-weight: 500;
	}
`;

export { StyledContainer };
